module.exports = __webpack_public_path__ + "img/video1-placeholder.167b5536.png";